import { createPortal, useRef, useState } from 'preact/compat'
import Icon from '@/components/snippets/icon/icon'
import clsx from 'clsx'
import { globalState } from '@/components/helpers/utils'

export const SearchHeader = ({ query, totalResults, isLoading, corrections }) => {
  const searchHeader = document.querySelector('#search-results')
  const content = useRef(searchHeader ? searchHeader.innerHTML : '')
  const hasMounted = useRef(false)
  const [inputValue, setInputValue] = useState(query)

  const handleSearch = (e) => {
    e.preventDefault()
    window.location.href = `${globalState.routes.root}/search?query=${inputValue}`
  }

  if (!searchHeader) {
    return null
  }

  if (!hasMounted.current) {
    hasMounted.current = true
    searchHeader.innerHTML = ''
  }

  return createPortal(
    <div className={'flex flex-col gap-4'} data-results={totalResults}>
        <h1 className={clsx('h5 md:h4 w-fit', isLoading && 'bg-neutral-medium text-neutral-medium animate-pulse')}>
            {totalResults} results for "{corrections?.corrected ? corrections?.corrected : query}"
        </h1>
        {corrections?.corrected && (
            <div className={clsx('paragraph-md text-neutral-secondary', isLoading && 'bg-neutral-medium text-neutral-medium animate-pulse')}>
                No results found for "{query}". Showing results for "{corrections.corrected}" instead.
            </div>
        )}
        {corrections?.didYouMean && (
            <div className={clsx('paragraph-md text-neutral-secondary', isLoading && 'bg-neutral-medium text-neutral-medium animate-pulse')}>
                Did you mean: <a href={`${globalState.routes.root}/search?query=${corrections.didYouMean}`}>{corrections.didYouMean}</a>
            </div>
        )}
        {totalResults === 0 && !isLoading && (
            <div className={'[&>div]:!block'} dangerouslySetInnerHTML={{ __html: content.current }} />
        )}
        <form action={`${globalState.routes.root}/search`} method="get" className="md:w-96 ">
            <div className={clsx('border-none field-control field-xl bg-brand-white', isLoading && 'bg-neutral-medium text-neutral-medium animate-pulse')}>
                <input
                    className={clsx('px-4 field-input field-xl placeholder-neutral-secondary', isLoading && 'invisible')}
                    type="text"
                    name="query"
                    placeholder={query}
                    value={inputValue}
                    onInput={(e) => setInputValue(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        handleSearch(e)
                      }
                    }}
                />
                <Icon id="magnifying-glass" className="field-icon right-2 z-1" onClick={handleSearch} />
            </div>
        </form>
    </div>, searchHeader
  )
}
